import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  news: NewsItem;
}

export default function NewsCard({ news }: NewsCardProps) {
  return (
    <Link
      to={`/news/${news.id}`}
      className="group flex gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-28 h-20 md:w-40 md:h-28 shrink-0 rounded-md overflow-hidden bg-background-200">
        <img
          src={news.cover}
          alt={`${news.title} 配图`}
          title={`${news.title} - 动漫资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex flex-col min-w-0 flex-1">
        <div className="flex items-center gap-2 text-[11px] text-foreground-600">
          <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 font-medium">
            {news.categoryLabel}
          </span>
          <span className="hidden sm:inline">{news.publishedAt}</span>
        </div>
        <h3 className="mt-1.5 font-heading font-semibold text-foreground-950 text-sm md:text-base line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
          {news.title}
        </h3>
        <p className="hidden sm:block mt-1 text-xs text-foreground-600 line-clamp-2 leading-relaxed">{news.summary}</p>
        <div className="mt-auto pt-1.5 flex items-center gap-3 text-[11px] text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-newspaper-line" />
            {news.source}
          </span>
          <span className="sm:hidden inline-flex items-center gap-1">
            <i className="ri-time-line" />
            {news.publishedAt}
          </span>
        </div>
      </div>
    </Link>
  );
}